import React from "react";
import * as Yup from "yup";
import { useFormik } from "formik";
import { Button } from "primereact/button";
import InputText from "../../../../components/form-control/input-text";
import { useNavigate } from "react-router-dom";
import { Card } from 'primereact/card';
import { ArrowLeftIcon } from "@heroicons/react/24/outline";

const BusinessMemTagCreate: React.FC = () => {
    const navigate = useNavigate();

    const validationSchema = Yup.object().shape({
        name: Yup.string().required("Name is required!"),
    });

    const initialValue = {
        name: "",
    };

    const formik = useFormik({
        initialValues: initialValue,
        validationSchema: validationSchema,

        onSubmit: async (values: any) => {
            console.log(values, "values");
            navigate("/admin/");
            // let pass: any = cryptoHelper.generatePassword(values.password);
            // let encodedPassword = encodeURIComponent(pass);
            // let payload = {
            //   email: values.email,
            //   password: encodedPassword,
            // };
            // login(payload);
        },
    });

    const handleBack = () => {
        navigate('/admin//businessmemtag');
    }

    return (
        <>
            <div className="back-button" onClick={handleBack}>
                <ArrowLeftIcon className="w-6 h-6 text-black-700" /><h3 className="m-0">Back</h3>
            </div>
            <div className="page-title">
                <h3>Add Business Member Tag</h3>
            </div>
            <form action="submit" onSubmit={formik.handleSubmit}>
                <Card className="grid form-layout">
                    <div className="grid grid-cols-12 gap-4">
                        <div className="col-span-12 md:col-span-6">
                            <InputText
                                type="text"
                                label="Name"
                                placeholder=""
                                modelValue={formik.values.name}
                                disabled={false}
                                autofocus={true}
                                id="name"
                                validation={
                                    formik.errors.name &&
                                    formik.touched.name && {
                                        $error: true,
                                        required: {
                                            $invalid: true,
                                            $message: formik.errors.name,
                                        },
                                    }
                                }
                                onUpdateModelValue={function (value: string): void {
                                    formik.setFieldValue("name", value);
                                }}
                            />
                        </div>
                    </div>
                    <div className="grid grid-cols-12 gap-4">
                        <div className="field mt-5 mb-4">
                            <Button
                                label="ADD"
                                className="prime-button btn-login w-max"
                                type="submit"
                            ></Button>
                        </div>
                    </div>
                </Card>
            </form >
        </>
    );
};

export default BusinessMemTagCreate;
